module.exports = require('./lib/bloodhound');



/** WEBPACK FOOTER **
 ** ./index.js
 **/